<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Location"
    size="lg"
    @on-hide="resetFormData"
  >
    <locations-form
      v-bind="value"
      @on-submit="updateLocation"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import LocationsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'LocationsEditModal',
  mixins: [formModalMixin],
  components: {
    LocationsForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: 'location-edit-modal',
    };
  },
  methods: {
    updateLocation(data, handleUpdate) {
      handleUpdate(this.$locationsAPI.update(this.$route.params.id, data));
    },
    onSave(location) {
      this.closeModal();
      this.$emit('input', location);
    },
  },
};
</script>
